export default (phoneNumber: string | null) => {
  if (!phoneNumber) return null;

  return phoneNumber.replace(/^\+/, '');
};
